// 相关样衣 升级样衣：operationType = 106，sampleName，sampleId，sampleCode 会赋值
// 相关款式：operationType = 201，inspirationId，blogId，collectId 会赋值
// 移动款式：operationType = 109，inspirationId，inspirationName 会赋值
// 关联选款任务：operationType = 114，missionId，missionTargetId 会赋值
// 移动样衣：operationType = 212，sampleFolderId，sampleFolderName 会赋值

export const hasRelateUrl = (data = {}) => {
  if (data.operationType === 106 && data.sampleName && data.sampleId && data.sampleCode) {
    return `/meinian/detail/sample/image?sampleCode=${data.sampleCode}`
  }
  if (data.operationType === 201 && data.inspirationId && data.blogId && data.collectId) {
    return `/meinian/detail/image?imageGroupEntityId=${data.blogId}&inspirationId=${data.inspirationId}&collectId=${data.collectId}&trackSourceType=样衣详情`
  }
  if (data.operationType === 109 && data.inspirationId !== -1 && data.inspirationId && data.inspirationName) {
    return `/meinian/home/coll/detail/${data.inspirationId}?inspirationId=${data.inspirationId}&tab=`
  }
  return null
}
